/*       */
import Immutable from 'app/utils/immutable/Immutable';
import { get } from 'app/utils/lo/lo';
import { LOAD_SUBPROCESS_TASKS_STARTED, LOAD_SUBPROCESS_TASKS } from 'store/actions/abox/taskActions';

export default (state = {}, action = {}) => {
    const { type, payload, error, meta } = action;
    switch (type) {
        case LOAD_SUBPROCESS_TASKS_STARTED: {
            const { processId } = meta || {};
            let processTasksState = get(state, processId) || {};
            processTasksState = { ...processTasksState, isLoading: true };
            return Immutable({ ...state, [processId]: processTasksState });
        }
        case LOAD_SUBPROCESS_TASKS: {
            const { processId } = meta || {};
            let processTasksState = get(state, processId) || {};
            if (error) {
                processTasksState = { ...processTasksState, isLoading: false };
            } else {
                processTasksState = { ...processTasksState, isLoading: false, data: payload };
            }
            return Immutable({ ...state, [processId]: processTasksState });
        }
        default:
            return state;
    }
};
